<template>
  <section class="page-wrap">
    <UiPageHero
      eyebrow="Trang chủ"
      title="Quản lý tài sản Mobifone"
      description="Theo dõi tài sản, tình trạng bàn giao, thiết bị hết hạn và báo cáo vận hành trong một dashboard thống nhất."
    />

    <div class="grid gap-4 md:grid-cols-3">
      <router-link
        v-for="item in cards"
        :key="item.to"
        :to="item.to"
        class="panel-pad group block transition hover:-translate-y-0.5 hover:border-brand-200"
      >
        <div
          class="mb-3 grid h-10 w-10 place-items-center rounded-xl bg-brand-50 text-xl font-black text-brand-700"
        >
          {{ item.icon }}
        </div>
        <p class="text-lg font-bold text-ink">{{ item.title }}</p>
        <p class="mt-2 text-xs leading-5 text-slate-500">{{ item.desc }}</p>
        <span class="mt-3 inline-flex text-sm font-bold text-brand-600"
          >Mở chức năng →</span
        >
      </router-link>
    </div>
  </section>
</template>

<script lang="ts">
export default {
  setup() {
    const cards = [
      {
        title: "Tổng quan",
        desc: "Xem nhanh các chỉ số thiết bị và biểu đồ theo tháng.",
        icon: "01",
        to: "/chartPage",
      },
      {
        title: "Tiếp nhận thiết bị",
        desc: "Tạo thiết bị mới và phân bổ về khoa/phòng sử dụng.",
        icon: "02",
        to: "/inputDevice",
      },
      {
        title: "Báo cáo",
        desc: "Xuất báo cáo tổng hợp hoặc theo giá trị tài sản.",
        icon: "03",
        to: "/reportPage",
      },
    ];
    return { cards };
  },
};
</script>
